var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        id: "Profile_Picture_Empty",
        "data-name": "Profile Picture Empty",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        width: "95",
        height: "95",
        viewBox: "0 0 95 95"
      }
    },
    [
      _c(
        "defs",
        [
          _c("clipPath", { attrs: { id: "clip-path" } }, [
            _c("circle", {
              attrs: {
                id: "jake-davies-FoVlxDABKQc-unsplash",
                cx: "47.5",
                cy: "47.5",
                r: "47.5",
                fill: "#fafafa",
                stroke: "#f3f3f3",
                "stroke-width": "1.5"
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "linearGradient",
            {
              attrs: {
                id: "linear-gradient",
                x1: "0.403",
                y1: "0.741",
                x2: "1.238",
                y2: "-1.918",
                gradientUnits: "objectBoundingBox"
              }
            },
            [
              _c("stop", { attrs: { offset: "0", "stop-opacity": "0" } }),
              _vm._v(" "),
              _c("stop", { attrs: { offset: "1", "stop-opacity": "0.502" } })
            ],
            1
          ),
          _vm._v(" "),
          _c("linearGradient", {
            attrs: {
              id: "linear-gradient-2",
              x1: "0.414",
              y1: "1",
              x2: "1.964",
              y2: "-1.85",
              "xlink:href": "#linear-gradient"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "CIRCLE",
            fill: "#fafafa",
            stroke: "rgba(0,0,0,0.1)",
            "stroke-width": "1.5"
          }
        },
        [
          _c("circle", {
            attrs: { cx: "47.5", cy: "47.5", r: "47.5", stroke: "none" }
          }),
          _vm._v(" "),
          _c("circle", {
            attrs: { cx: "47.5", cy: "47.5", r: "46.75", fill: "none" }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "g",
        {
          attrs: {
            id: "Mask_Group_65",
            "data-name": "Mask Group 65",
            "clip-path": "url(#clip-path)"
          }
        },
        [
          _c(
            "g",
            {
              attrs: {
                id: "Group_4378",
                "data-name": "Group 4378",
                transform: "translate(12.136 17.72)"
              }
            },
            [
              _c("path", {
                attrs: {
                  id: "Path_634",
                  "data-name": "Path 634",
                  d:
                    "M360,387.595a34.972,34.972,0,0,0-34.97,34.97v4.383a10.678,10.678,0,0,0,10.677,10.672h48.59a10.677,10.677,0,0,0,10.672-10.672v-4.383A34.973,34.973,0,0,0,360,387.595Z",
                  transform: "translate(-325.028 -346.797)",
                  fill: "url(#linear-gradient)"
                }
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  id: "Path_635",
                  "data-name": "Path 635",
                  d:
                    "M346.641,416.56a18.42,18.42,0,1,0-18.418-18.417A18.416,18.416,0,0,0,346.641,416.56Z",
                  transform: "translate(-311.671 -379.72)",
                  fill: "url(#linear-gradient-2)"
                }
              })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }